<div [attr.id]="'checkout-step-' + name"
     [class.ng-hide]="!isStepVisible">
    <ng-content></ng-content>
</div>